import { Injectable } from '@angular/core';

export const cachedRequests = new Map<string, Promise<unknown>>();
export const cachedIcons = new Map<string, string>();
@Injectable()
export class IconService {

  async getIcon(iconName: string): Promise<unknown> {
    let request = cachedRequests.get(iconName);

    if (!request) {
      const iconPath = `/assets/icons/${iconName}.svg`;

      request = fetch(iconPath).then((response) => {
        if (response.ok) {
          return response.text().then((svg) => {
            if (svg.startsWith('<svg')) {
              cachedIcons.set(iconName, svg);
            }
          });
        }

        cachedIcons.set(iconName, '');
      });

      cachedRequests.set(iconName, request);
    }

    return request;
  }
}
